// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectControlAlertCommandMessage } from '@shared/utils/DirectMessages/DirectMessagesImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
export class ControlAlertCommandMessageProcessor extends MessageProcessorBase {
    decode(fs) {
        const msg = new DirectControlAlertCommandMessage();
        msg.AlertId = fs.GetValue(FieldsFactory.FIELD_ALERT_ID);
        msg.AlertCommand = fs.GetValue(FieldsFactory.FIELD_ALERT_COMMAND);
        return [msg];
    }
}
